import { Injectable, inject } from "@angular/core";
import { GenericItems } from "../../../shared/interfaces/generic-items.interface";
import { LorenUsersEndpointsService } from "../../../shared/services/loren-users-endpoints-service/loren-users-endpoints.service";
import { LorenUserInfo } from "../../../shared/interfaces/loren-user-info.interface";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class LorenCompanyUsersService {
  private http = inject(HttpClient);
  private endpoints = inject(LorenUsersEndpointsService);


  getCompanyUsers() {
    return this.http.get<GenericItems<Partial<LorenUserInfo>>>(
      this.endpoints.users(),
      {}
    );
  }

  assignGroupsToUser(userId: number, groupIds: number[]) {
    return this.http.put(this.endpoints.assignGroupsToUser(userId), {
      canAccessGroups: groupIds,
    });
  }
}
